<template>
  <b-modal
    :id="id"
    title="Select Examinees for Export"
    size="lg"
    @show="resetModal"
    @hidden="resetModal"
    @ok="handleOk"
  >
    <b-table
      :borderless="true"
      head-variant="light"
      :fields="[
          {
            key: 'user.username',
            label: 'Username',
            sortable: true
          },
          {
            key: 'name',
            label: 'Name',
            sortable: true
          },
          {
            key: 'status',
            label: 'Status',
            sortable: true,
          },
          {
            key: 'include',
            label: 'Include',
            sortable: true,
          },
        ]"
      :items="examineeList"
    >
      <template v-slot:head(include)="data">
        <b-form-checkbox
          v-model="toggleAll"
          name="toggleAll"
          :label="data.label"
        >{{ data.label }}</b-form-checkbox>
      </template>
      <template v-slot:cell(name)="data">
        <span
          v-if="data.item.lastName && data.item.firstName"
        >{{ `${data.item.lastName }, ${data.item.firstName} ${data.item.middleInitial} `}}</span>
        <span v-else>Not Submitted</span>
      </template>
      <template v-slot:cell(include)="data">
        <b-form-checkbox
          v-model="selectedExaminees"
          name="selectedExaminees"
          :value="data.item.id"
        />
      </template>
    </b-table>

    <template v-slot:modal-footer="{ ok, cancel }">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="sm" variant="secondary" @click="cancel()">Cancel</b-button>
      <b-button size="sm" variant="primary" class="bg-site-primary" :disabled="!isFormValid ? `disabled` : null " @click="ok()">Export</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: `ExamineeReportModal`,
  data() {
    return {
      selectedExaminees: [],
      dispatchPath: null,
      toggleAll: false,
    };
  },
  props: {
    id: String,
    clientId: String,
    examineeList: Array,
  },
  watch: {
    toggleAll(isToggled) {
      if(isToggled && this.examineeListId){
        this.selectedExaminees = this.examineeListId;
      }
      else{
        this.selectedExaminees = []
      }
    }
  },
  computed: {
    examineeListId() {
      var idArray = []
      if(Array.isArray(this.examineeList)){
        idArray = this.examineeList.map(examinee => examinee.id)
      }
      return idArray
    },
    isFormValid(){
      var isDispatchValid = this.dispatchPath != null
      var isSelectionValid = Array.isArray(this.selectedExaminees) && this.selectedExaminees.length > 0
      return isDispatchValid && isSelectionValid
    },
  },
  methods: {
    resetModal() {
      this.selectedExaminees = [];
    },
    handleOk() {
      // Check if Value changed
      var exportMethod = null;
      switch(this.dispatchPath){
          case `examinee/getAllByIdFlat`:
            exportMethod = this.exportExaminees
            break;
          case `examineeAnswer/getAllOfExaminees`:
            exportMethod = this.exportExamineeAnswers
            break;
      }

      if(exportMethod){
        exportMethod()
          .then(() => {
            this.$emit("ok");
          });
      }
    },
    exportExaminees() {
      const idArray = this.selectedExaminees;
      return this.$store
        .dispatch("examinee/getAllFlat", { idArray })
        .then((data) => {
          this.downloadCSVData(
            data.data,
            "examinees-" + new Date().toISOString()
          );
        });
    },
    exportExamineeAnswers() {
      const idArray = this.selectedExaminees;
      return this.$store
        .dispatch("examineeAnswer/getAllOfExaminees", { idArray })
        .then((data) => {
          this.downloadCSVData(
            data.data,
            "examinee-answers-" + new Date().toISOString()
          );
        });
    },
    downloadCSVData(dataArray, fileName) {
      let csvString = "";
      // Get

      var firstObject = dataArray[0];
      for (var header in firstObject) {
        csvString += `${header},`;
      }
      csvString += "\n";

      dataArray.forEach((rowObject) => {
        for (var key in rowObject) {
          csvString += `${rowObject[key]},`;
        }
        csvString += "\n";
      });

      let anchor = document.createElement("a");
      anchor.href =
        "data:text/csv;charset=utf-8," + encodeURIComponent(csvString);
      anchor.target = "_blank";
      anchor.download = fileName + ".csv";
      anchor.click();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>